import React from 'react';
import { VictoryLabel, VictoryPie, VictoryTooltip } from 'victory';
import euroleaf from '../../images/euroleaf.png';
import IndicatorsPool from '../../js/IndicatorsPool';
import ParametersPool from '../../js/ParametersPool';
import Translations from '../../js/Translations';
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';
import { store } from '../../stores/store';
import MyTooltip from '../AepPopup/WarehouseCharts/MyTooltip/MyTooltip';
import './MyFarmPopup.css';




function CustomLabel(props) {
  const fill1 = props.color || "#FFF"
  const fill2 = fill1 === "#FFF" ? "black" : "white"

  return (
    <g>
      <VictoryLabel {...props} text={props.datum.shortLabel} style={{fill: fill2, stroke: fill2, strokeWidth:3 }} />
      <VictoryLabel {...props} text={props.datum.shortLabel} style={{fill: fill1}} />
      {!props.hideTooltip && <MyTooltip {...props} />}
    </g>
  )
}
CustomLabel.defaultEvents = VictoryTooltip.defaultEvents;






function makeLabel(id, alternative_title) {
  let labelVal = IndicatorsPool.getIndicatorValue(id, true)
  let labelInd = IndicatorsPool.getIndicator(id)
  let unit = labelInd.unit ? labelInd.unit : ""

  let final_label = alternative_title ? alternative_title : labelInd.title
  final_label += Translations.chartSeparator + labelVal + unit
  return final_label
}

// renvoie un objet correct pour faire un portion de camembert
function makeSlice(id, labelIndId) {
  let val = IndicatorsPool.getIndicatorValue(id, true)
  let shortLabel = makeLabel(id)
  return {
    x: id,
    y: parseFloat(val),
    label: labelIndId ? makeLabel(labelIndId) : shortLabel,
    shortLabel
  }
}

// idem que makeslice mais on cherche le label dans le fichier de trads
function makeSliceTranslationLabel(id, trad_id) {
  let val = IndicatorsPool.getIndicatorValue(id, true)
  let shortLabel = makeLabel(id, store.t(trad_id))

  return {
    x: id,
    y: parseFloat(val),
    label: shortLabel,
    shortLabel
  }
}


function makeUAAX_surface(id) {
  const ind = IndicatorsPool.getIndicator(id)
  const val = IndicatorsPool.getIndicatorValue(id, true)
  const shortLabel = val + ind.unit
  return [{
    x: 1,
    y: val,
    label: ind.title + Translations.chartSeparator + shortLabel,
    shortLabel
  }]

}

const correspondances = {
  "indCr19.UAA1" : "indF107",
  "indCr20.UAA1" : "indF109",
  "indCr21.UAA1" : "indF111",
  "indCr22.UAA1" : "indF112",
  "indCr23.UAA1" : "indF113",
  "indCr24.UAA1" : "indF114",
  "indCr25.UAA1" : "indF115",
  "indCr26.UAA1" : "indF116",
  "indCr27.UAA1" : "indF117",
  "indCr28.UAA1" : "indF118",
  "indCr29.UAA1" : "indF119",

  "indCr19.UAA2" : "indF120",
  "indCr20.UAA2" : "indF122",
  "indCr21.UAA2" : "indF124",
  "indCr22.UAA2" : "indF125",
  "indCr23.UAA2" : "indF126",
  "indCr24.UAA2" : "indF127",
  "indCr25.UAA2" : "indF128",
  "indCr26.UAA2" : "indF129",
  "indCr27.UAA2" : "indF130",
  "indCr28.UAA2" : "indF131",
  "indCr29.UAA2" : "indF132",


}


const MyFarmPopup = () => {

  // CHART #1
  const outer_pie_data = [{
    x: 1,
    y: ParametersPool.getDef("paramF1"),
    label: store.t('paramF1') + ParametersPool.getDef("paramF1") + store.t("paramF1_unit"),
    shortLabel: ParametersPool.getDef("paramF1") + IndicatorsPool.getIndicator("indCr19.UAA1").unit
  }]
  let inner_pie_data = ["indCr239", "indF139", "indF140"].map(id => makeSliceTranslationLabel(id, id + "_label"))
  for(let i = 170; i<= 180; i++) {
    let id = "indF" + i
    inner_pie_data.push(makeSliceTranslationLabel(id, id + "_label"))
  }
  inner_pie_data = inner_pie_data.filter(d => d.y > 0)

  // CHART #2
  const c12x_id = store.selectedActions.cropping_system_1 // pour le titre
  let uaa1_surface = makeUAAX_surface("indCr237")
  let uaa1_data = []
  for(let i = 19; i<= 29; i++) {
    let indId = "indCr" + i + ".UAA1"
    let ttipIndId = correspondances[indId]
    uaa1_data.push(makeSlice(indId, ttipIndId))
  }
  uaa1_data = uaa1_data.filter(d => d.y > 0)


  // CHART #3
  const c13x_id = store.selectedActions.cropping_system_2 // pour le titre
  let uaa2_surface = makeUAAX_surface("indCr238")
  let uaa2_data = []
  for(let i = 19; i<= 29; i++) {
    let indId = "indCr" + i + ".UAA2"
    let ttipIndId = correspondances[indId]
    uaa2_data.push(makeSlice(indId, ttipIndId))
  }
  uaa2_data = uaa2_data.filter(d => d.y > 0)


  // CHART #4
  let meat_prod = [makeSlice("indAn128")]
  let milk_prod = [makeSlice("indAn127")]

  let animals = []
  for(let i = 1; i<= 4; i++) {
    let id = "indAn" + i
    animals.push(makeSliceTranslationLabel(id, id + "_label"))
  }
  animals = animals.filter(d => d.y > 0)



  return (
  <>
    <div className="overlay" onClick={() => PopupStore.close(POPUPS_IDS.MYFARM)} />
    <div className="MyFarmPopup">
      <div className="title">{store.t("my_farm_title")}</div>
      <div className="content">

        <div className="type_farming">
          <h3>{store.t("farm_localization")}</h3>
          <span>{store.t(store.country)}</span>
        </div>

        <div className="type_farming">
          <h3>{store.t("type_of_farming")}</h3>
          {IndicatorsPool.getIndicatorValue("indGl1") === 1 && <span>{store.t("type_of_farming_organic")} <img src={euroleaf} className="euroleaf" alt="euroleaf"/></span>}
          {!(IndicatorsPool.getIndicatorValue("indGl1") === 1) && <span>{store.t("type_of_farming_conventional")}</span>}
        </div>

        <div className="type_farming">
          <h3>{store.t("permanent_workers_nb")}</h3>
          <span>{ParametersPool.getDef("paramF6")}</span>
        </div>



        <h3>{store.t("crop_rotation_and_production")}</h3>

        <div className="pie-chart">
          <VictoryPie
          data={outer_pie_data}
          innerRadius={140}
          radius={175}
          labelRadius={150}
          colorScale={["chocolate"]}
          labelComponent={<CustomLabel />} />

          <VictoryPie
          radius={125}
          labelComponent={<CustomLabel hideTooltip={true} />}
          labelRadius={50}
          colorScale="green"
          data={inner_pie_data} />
        </div>

        <div className="two-cols">

          <div className="pie-chart">

            <h4>{store.t(c12x_id)}</h4>

            <VictoryPie
            data={uaa1_surface}
            innerRadius={125}
            radius={150}
            labelRadius={130}
            labelComponent={<CustomLabel />}
            colorScale={["chocolate"]} />

            <VictoryPie
            data={uaa1_data}
            radius={120}
            labelRadius={20}
            labelComponent={<CustomLabel />}
            colorScale={["#3A5A4A","#537A60","#6D9774","#8AB389","#AECEA6","#B9DABA","#CCE5D3","#E0F0E8"]}/>
          </div>

          <div className="pie-chart">

            <h4>{store.t(c13x_id)}</h4>

            <VictoryPie
            data={uaa2_surface}
            innerRadius={125}
            radius={150}
            labelRadius={130}
            labelComponent={<CustomLabel />}
            colorScale={["chocolate"]} />

            <VictoryPie
            data={uaa2_data}
            radius={120}
            labelRadius={20}
            colorScale={["#003D13", "#005B0B", "#007400", "#1C8802", "#479711", "#4CA03B", "#62AB67", "#87B895"]}
            labelComponent={<CustomLabel />}
            />
          </div>
        </div>




        <h3>{store.t("herd_size_and_animal_production")}</h3>

        <div className="pie-chart">

          <VictoryPie
          data={milk_prod}
          innerRadius={165}
          radius={195}
          labelRadius={170}
          colorScale={["#FFF"]}
          labelComponent={<CustomLabel hideTooltip={true}/>} />


          <VictoryPie
          data={meat_prod}
          innerRadius={130}
          radius={160}
          labelRadius={137}
          colorScale={["darkred"]}
          labelComponent={<CustomLabel hideTooltip={true} />} />

          <VictoryPie
          radius={125}
          labelComponent={<CustomLabel hideTooltip={true} />}
          labelRadius={50}
          colorScale="red"
          data={animals} />

        </div>

      </div>
    </div>
  </>
  );
};

export default MyFarmPopup;
